export const paintCycle = () => new Promise(resolve => requestAnimationFrame(resolve));
